import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import type { BusinessType } from "../types";

export type BusinessLabelKey =
  | "entity"
  | "client"
  | "service"
  | "queue"
  | "readyMessage"
  | "joinTitle"
  | "event"
  | "eventCodeHint"
  | "presentNow";

export type BusinessLabels = Record<BusinessLabelKey, string>;

const LABEL_KEYS: BusinessLabelKey[] = [
  "entity",
  "client",
  "service",
  "queue",
  "readyMessage",
  "joinTitle",
  "event",
  "eventCodeHint",
  "presentNow",
];

export const getBusinessLabels = (
  businessType: BusinessType = "OTHER",
  t: (key: string) => string,
): BusinessLabels => {
  const type = businessType ?? "OTHER";
  const read = (key: BusinessLabelKey): string =>
    t(`business.${type}.${key}`);

  return LABEL_KEYS.reduce((acc, key) => {
    acc[key] = read(key);
    return acc;
  }, {} as BusinessLabels);
};

export const useBusinessLabels = (
  businessType: BusinessType = "OTHER",
): BusinessLabels => {
  const { t } = useTranslation();
  return useMemo(
    () => getBusinessLabels(businessType, t),
    [businessType, t],
  );
};
